// Geometry helpers for the existing Spatial Home layout; coordinates stay in percent.
const round2 = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
const validDimension = (value) => typeof value === "number" && Number.isFinite(value) && value >= 0.5 && value <= 200;

export const parseFloorDimensions = (width, depth) => {
  if (String(width ?? "").trim() === "" || String(depth ?? "").trim() === "") return null;
  const width_m = Number(width);
  const depth_m = Number(depth);
  if (!validDimension(width_m) || !validDimension(depth_m)) return null;
  return { width_m: round2(width_m), depth_m: round2(depth_m) };
};

export const getFloorScale = (floor) => {
  if (floor?.dimensions_confirmed !== true || !validDimension(floor.width_m) || !validDimension(floor.depth_m)) return null;
  return { width_m: floor.width_m, depth_m: floor.depth_m };
};

export const getRoomMeasurements = (placement, floor) => {
  const scale = getFloorScale(floor);
  if (!scale || !placement || ![placement.width, placement.height].every((value) => Number.isFinite(value) && value > 0 && value <= 100)) return null;
  const width = placement.width * scale.width_m / 100;
  const depth = placement.height * scale.depth_m / 100;
  return { width: round2(width), depth: round2(depth), area: round2(width * depth) };
};

export const nextSpatialElementId = (prefix, elements) => {
  const used = new Set(elements.map((element) => element.id));
  const base = prefix.slice(0, 100);
  let index = 1;
  while (used.has(`${base}-${index}`)) index += 1;
  return `${base}-${index}`;
};

export const moveSpatialItem = (item, kind, x, y) => {
  if (!item || !["room", "wall", "opening"].includes(kind)) return item;
  const width = kind === "wall" ? (item.orientation === "vertical" ? item.thickness : item.length) : item.width;
  const height = kind === "wall" ? (item.orientation === "vertical" ? item.length : item.thickness) : item.height;
  if (![x, y, width, height].every(Number.isFinite) || width <= 0 || height <= 0 || width > 100 || height > 100) return item;
  return {
    ...item,
    x: round2(Math.max(0, Math.min(100 - width, x))),
    y: round2(Math.max(0, Math.min(100 - height, y))),
  };
};

export const spatialPointerPosition = (bounds, clientX, clientY, offsetX = 0, offsetY = 0) => {
  if (!bounds || ![bounds.left, bounds.top, bounds.width, bounds.height, clientX, clientY, offsetX, offsetY].every(Number.isFinite) || bounds.width <= 0 || bounds.height <= 0) return null;
  return {
    x: (clientX - bounds.left) / bounds.width * 100 - offsetX,
    y: (clientY - bounds.top) / bounds.height * 100 - offsetY,
  };
};

export const parseSpatialDrag = (payload) => {
  try {
    const value = JSON.parse(payload);
    if (!value || !["room", "wall", "opening"].includes(value.kind) || typeof value.id !== "string" || !value.id || value.id.length > 120 || typeof value.floorId !== "string") return null;
    if (![value.offsetX, value.offsetY].every(Number.isFinite)) return null;
    return value;
  } catch {
    return null;
  }
};
